module.exports = __webpack_public_path__ + "img/send.d9f34237.svg";